// extracted by mini-css-extract-plugin
export default {"about":"Aboutme_about__BuuX-","right":"Aboutme_right__se+lI","mainAbout":"Aboutme_mainAbout__t3sOW","leftProfile":"Aboutme_leftProfile__kmGmB"};